import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid, makeStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import brandTheme from "brandTheme/Theme";
import GridItem from "components/Grid/GridItem";

const style = () => ({
  viewerContainer: {
    textAlign: "center",
    marginTop: "10px",
    overflow: "auto",
  },
  image: {
    maxWidth: "100%",
    maxHeight: "75vh",
    borderRadius: "8px",
    transition: "transform 0.2s ease",
    transformOrigin: "center center",
  },
  pdfViewer: {
    width: "100%",
    height: "75vh",
    border: "none",
    borderRadius: "8px",
  },
  textField: {
    display: "block",
    width: "100%",
    borderColor: brandTheme.black,
    "& .Mui-disabled": {
      color: brandTheme.fieldColor,
    },
    "& .MuiInputBase-input": {
      padding: "10px",
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: "0 12px",
      },
    },
     "& .MuiFormLabel-root": {
          fontFamily: brandTheme.font.Poppins,
        },
    "& .MuiFormLabel-root.Mui-error": {
      color: brandTheme.errorColor,
    },
    "& .MuiInputLabel-outlined": {
      top: "-7px",
      color: brandTheme.black,
      "@media (max-width:768px)": {
        fontSize: "13px",
      },
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: brandTheme.black,
      top: "0px",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
      "& :hover": {
        borderColor: brandTheme.black,
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: brandTheme.black,
    },
  },
  deleteButton: {
    position: "absolute",
    bottom: "15px",
    right: "-65px",
  },
  minAmountContainer: {
    position: "relative",
  },
  textInput: {
    marginBottom: "2%",
  },
});

const useStyles = makeStyles(style);

const ViewImage = ({ closeModal, imageUrl }) => {
  const classes = useStyles();

  const [scale, setScale] = useState(1);

  useEffect(() => {
    const handleKeyDown = (e) => {
      const modifierPressed = e.ctrlKey || e.metaKey;
    
      if (!modifierPressed) return;
    
      if (e.key === "+" || e.key === "=") {
        e.preventDefault();
        setScale((prev) => Math.min(prev + 0.1, 5));
      }
    
      if (e.key === "-") {
        e.preventDefault();
        setScale((prev) => Math.max(prev - 0.1, 0.5));
      }
    
      if (e.key === "0") {
        e.preventDefault();
        setScale(1);
      }
    };
  
    window.addEventListener("keydown", handleKeyDown);
  
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleWheel = (e) => {
    if (e.ctrlKey) {
      e.preventDefault();

      setScale((prev) => {
        const newScale = e.deltaY < 0 ? prev + 0.1 : prev - 0.1;
        return Math.max(0.5, Math.min(newScale, 5));
      });
    }
  };

  const handleCancelUser = () => {
    closeModal();
  };

  const isPdf = imageUrl?.toLowerCase().includes(".pdf");

  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label={isPdf ? "View PDF" : "View Image"}
            button1="Cancel"
            button1click={handleCancelUser}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div className={classes.viewerContainer} onWheel={handleWheel}>
            {isPdf ? (
              <iframe
                src={imageUrl}
                title="PDF Viewer"
                className={classes.pdfViewer}
              />
            ) : (
              <img
                src={imageUrl}
                alt="Preview"
                className={classes.image}
                style={{
                  transform: `scale(${scale})`,
                }}
              />
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

ViewImage.propTypes = {
  closeModal: PropTypes.func,
  imageUrl: PropTypes.string,
};

export default ViewImage;